// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"e7142302","411":"b4f1a0aa","577":"17d3299b","727":"38828860","896":"1dea96d5","921":"cf6dfe34","954":"4714633b"}[chunkId] + ".chunk.js";
};